import { render, staticRenderFns } from "./FieldCanvas.vue?vue&type=template&id=1cafbf4e&scoped=true&"
import script from "./FieldCanvas.vue?vue&type=script&lang=js&"
export * from "./FieldCanvas.vue?vue&type=script&lang=js&"
import style0 from "./FieldCanvas.vue?vue&type=style&index=0&id=1cafbf4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cafbf4e",
  null
  
)

export default component.exports